module.exports = __webpack_public_path__ + "static/icon-test-07d5bba0d8e6ff5d76b82a4267864b81.svg";